<template>
  <log-in/>
</template>

<script>
import LogIn from '../components/LogIn/index'
export default {
  components: {LogIn},
  created(){
    const token = localStorage.getItem('token');
    const homeurl = localStorage.getItem('homeurl');
    // if(localStorage.getItem('token')){
    if (token && homeurl) {
      this.$router.push(`/home-page`);
    }
    else{
      this.$router.push('/');
    }
  },

}
</script>

<style>

</style>
